.container {
  border-radius: 8px;
  border: 1px dashed #b4bbc7;
  padding: 32px;
}

.uploadLabel {
  display: inline-block;
  cursor: pointer;
  color: var(--mantine-color-brand-6);
  font-weight: 600;
}

.uploadLabel:hover {
  cursor: pointer;
  font-weight: 700;
}

.fileTypesLabel {
  color: var(--mantine-color-orange-6);
  font-weight: 500;
  cursor: default;
  border-bottom: 1px dashed var(--mantine-color-orange-6);
}
